<template>
    <BreadCrumb PageTitle="Liste des règles de tarification" />
    <ListePricingRule/>
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
  
    import BreadCrumb from "../../components/Common/BreadCrumb.vue";
    import ListePricingRule from "@/components/RegleTarification/ListePricingRule.vue";
  
    export default defineComponent({
      name: "ListeBescPricingRulePage",
      components: {
        BreadCrumb,
        ListePricingRule,
      },
    });
  </script>